import React, { useState } from 'react';

export default function ChangePassword() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setError(false);
  };

  const handleNext = () => {
    // TODO: 비밀번호 검증 로직
  };

  return (
    <div>
      <div className="flex justify-between items-center w-full">
        <h3 className="text-[26px] lg:text-[24px] font-black lg:font-bold leading-[130%] lg:leading-[100%]">Change Password</h3>
      </div>

      {/* 기존 비밀번호 입력박스 */}
      <div className={`mt-[50px] lg:mt-6 px-9 py-[30px] lg:p-[60px] bg-white rounded-[12px] border lg:border-none ${error ? 'border-[#F3652D]' : 'border-[#E4E8F1]'}`}>
        <p className="mb-8 text-center text-[18px] lg:text-[20px] font-bold leading-[120%]">기존 비밀번호를 입력하세요.</p>

        <div className="flex flex-col gap-2 max-w-[266px] mx-auto">
          <div className="w-full">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={handlePasswordChange}
              className={`w-full h-[44px] px-4 border rounded-[8px] text-[13px] placeholder-[#B4BCCC] outline-none ${error ? 'border-[#F3652D]' : 'border-[#E4E8F1]'}`}
            />
          </div>

          <div className="w-full text-center">
            <button
              onClick={handleNext}
              className="w-full max-w-[266px] h-[42px] text-[14px] text-white font-semibold bg-[#333] rounded-[12px] cursor-pointer"
            >
              Next
            </button>
          </div>
        </div>

        {error && (
          <p className="max-w-[266px] mx-auto mt-3 text-[13px] text-[#F3652D] leading-[100%]">Incorrect password.</p>
        )}
      </div>
    </div>
  );
}
